module.exports = __webpack_public_path__ + "static/img/quanfubg.a414517a.png";